// @flow

import React from 'react';
import styled, { css, withTheme } from 'styled-components';
import { ReskinThemes } from '../constants';
import PrimaryPalette from '../../birch/colors';

type Props = {
  cellHeight: string,
  cellWidthPercent: string,
  className?: string,
  columnsPerRow: number,
  rows: number,
  spaceBetween: string,
  theme?: { name: string },
};

const Skeleton = ({
  cellHeight,
  cellWidthPercent,
  className,
  columnsPerRow,
  rows,
  spaceBetween,
}: Props) => {
  const skeletonRows = Array.from(Array(rows)).map((_el, idx) => {
    return (
      <SkeletonRow
        className="skeleton-row"
        key={idx}
        spaceBetween={spaceBetween}
      >
        {Array.from(Array(columnsPerRow)).map((_el, idx) => (
          <SkeletonCell
            key={idx}
            height={cellHeight}
            width={cellWidthPercent}
          />
        ))}
      </SkeletonRow>
    );
  });

  return (
    <SkeletonWrapper className={className}>{skeletonRows}</SkeletonWrapper>
  );
};

const SkeletonCell = styled.div`
  height: ${(props) => props.height};
  width: ${(props) => props.width}%;

  ${(props) =>
    props.theme?.name === ReskinThemes.BIRCH &&
    css`
      border-radius: 5px;
    `}

  animation-duration: 1.2s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  background-image: -webkit-linear-gradient(
    left,
    ${(props) =>
        props.theme?.name === ReskinThemes.BIRCH
          ? PrimaryPalette.lightGrey
          : `#f3f3f3`}
      0%,
    ${(props) =>
        props.theme?.name === ReskinThemes.BIRCH
          ? PrimaryPalette.mediumGrey
          : `#edeef1`}
      20%,
    ${(props) =>
        props.theme?.name === ReskinThemes.BIRCH
          ? PrimaryPalette.lightGrey
          : `#f3f3f3`}
      40%,
    ${(props) =>
        props.theme?.name === ReskinThemes.BIRCH
          ? PrimaryPalette.lightGrey
          : `#f3f3f3`}
      100%
  );
  background-repeat: no-repeat;

  @keyframes placeHolderShimmer {
    0% {
      background-position: -100vw 0;
    }

    100% {
      background-position: ${(props) => props.width}vw 0;
    }
  }

  background-color: ${(props) =>
    props.theme?.name === ReskinThemes.BIRCH
      ? PrimaryPalette.lightGrey
      : `#f3f3f3`};
`;

const SkeletonRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  padding-top: ${(props) => props.spaceBetween};
  padding-bottom: ${(props) => props.spaceBetween};
`;

const SkeletonWrapper = styled.div`
  background-color: ${(props) =>
    props.theme?.name === ReskinThemes.BIRCH ? PrimaryPalette.white : `#fff`};
`;

export default withTheme(Skeleton);
